import React from 'react';
import classNames from 'classnames';

import { useAssets } from '../../hooks/useAssets';
import { IconSpinner } from '../../components';

import { HorseImage } from './HorseImage';
import css from './SwitchHorse.css';
import { SQUARE_SMALL_2X } from '../../ducks/Assets.duck';

export const Badge = ({ assetsLoadingRequests, mainListing, isSelected, onClick }) => {
    const {
        attributes: { title },
    } = mainListing;

    return (
        <div
            className={classNames(css.badge, {
                [css.selected]: !!isSelected,
            })}
            onClick={onClick}
        >
            <HorseImage listing={mainListing} />
            <span>{title}</span>
        </div>
    );
};
